export default "__VITE_ASSET__CR29KNxB__"